import { Component, Inject, Input, OnInit, SimpleChanges } from '@angular/core';
import { MedicalProvider, PatientsData, RenderFrom } from '../../models/commonmodel';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule, provideNativeDateAdapter } from '@angular/material/core';
import { debounceTime, distinctUntilChanged, filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RouterModule } from '@angular/router';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { NotificationService } from '../shared/services/notifications.service';
import { AgePipe } from "../shared/pipes/age.pipe";
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
import { ConfirmationMode } from '../shared/share';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomDateAdapter } from '../shared/pipes/custom-date-adapter';
import { MY_NATIVE_DATE_FORMATS } from '../shared/pipes/date-format';
import { MatRadioModule } from '@angular/material/radio';
import { InitialsPipe } from '../shared/pipes/intials.pipe';
import { PatientData } from '../../models/phase1models';
@Component({
  selector: 'app-add-patient',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    RouterModule,
    AgePipe,
    MatProgressSpinnerModule,
    MatRadioModule,
    InitialsPipe
  ],
  providers: [
    DatePipe, // optional, useful if you're formatting dates elsewhere
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ],
  templateUrl: './add-patient.component.html',
  styleUrl: './add-patient.component.scss'
})
export class AddPatientComponent implements OnInit {
selectedProvider(arg0: string) {
throw new Error('Method not implemented.');
}

  memberId: string | undefined;
  @Input() memberIdFromParent?: string;
  RenderFrom = RenderFrom;
  today = new Date();
  @Input() selectedPatient!: PatientData;
  @Input() patient!: PatientsData;
  patientForm !: FormGroup;
  @Input() isDismissable: boolean = false;
  @Input() renderForm!: string; // 'ADD' or 'REQUEST'
  uploadedFiles: { name: string }[] = []; // Store the list of uploaded files
  copiedEmail: string | null = null;
  memberSearchControl = new FormControl();
  filteredPatients: any[] = [];
  isMobile: boolean = false;
  addedProvidersList: MedicalProvider[] = [];
  documentList: any[] = [];
  enumConfirmationMode = ConfirmationMode;
  isSubmitLoading: boolean = false;
  userName = this.memberService.getLoginUserName();

  popupTitle = 'Request Medical Evidence';
  popupSubtitle = 'Please provide the necessary information to request medical evidence for the applicant.';

  selectedProviderId: any;
  showProviderError = false;

  selectProvider(id: any) {
    this.selectedProviderId = id;
    this.patientForm.patchValue({ providerId: id });
    this.showProviderError = false;
  }

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddPatientComponent>, private datepipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any, private restService: MemberInsurerRestService,
    private notificationService: NotificationService, private dialog: MatDialog, private memberService: MemberInsurerServiceService
  ) {
    this.patientForm = this.fb.group({
      firstName: ['', Validators.required,],
      lastName: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      gender: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]], // ✅ UK phone
      address: ['', Validators.required],
      nhsNumber: [''],
      comments: [''],
      consentToShareData: [false],
      providerId: ['']
    });

    if (data) {
      this.memberId = data.patientId;
    }


    if (this.memberIdFromParent) {
      this.memberId = this.memberIdFromParent;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('Input changes:', changes);
    this.memberId = changes['memberIdFromParent'].currentValue;
  }

  get formControls() {
    return this.patientForm.controls;
  }
  objectKeys = Object.keys;


  ngOnInit() {
    if (this.data) {
      this.patientForm.patchValue({
        patientId: this.data.patientId,
        firstName: this.data.firstName,
        lastName: this.data.lastName,
        dateOfBirth: new Date(this.data.dateOfBirth),
        gender: this.data.gender,
        email: this.data.email,
        phone: this.data.phone,
        address: this.data.address,
        nhsNumber: this.data.nhsNumber,
        consentToShareData: false
      });

    }

    if (this.renderForm == RenderFrom.REQUEST) { }
    this.getMappedProvider();

    if (this.memberId)
      this.getMemberById();

    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (this.renderForm === RenderFrom.REQUEST) {
      // this.patientForm.get('providerId')?.setValidators([Validators.required]);
      this.patientForm.get('consentToShareData')?.setValidators([Validators.requiredTrue]);
    } else {
      // this.patientForm.get('providerId')?.clearValidators();
      this.patientForm.get('consentToShareData')?.clearValidators();
    }
    // this.patientForm.get('providerId')?.updateValueAndValidity();
    this.patientForm.get('consentToShareData')?.updateValueAndValidity();


    this.memberSearchControl.valueChanges.pipe(
      debounceTime(300),
      map(value => typeof value === 'string' ? value.trim() : ''),  // Safely get string
      distinctUntilChanged(),
      filter(value => !!value && value.length >= 3),
      switchMap(value => this.restService.searchPatients(value.toLowerCase()))
    ).subscribe({
      next: (response) => {
        this.filteredPatients = response || [];
      },
      error: (err) => {
        console.error('Search failed:', err);
        this.filteredPatients = [];
      }
    });


  }

  onMemberSelected(patient: PatientsData): void {
    this.memberId = patient.patientId;
    this.disableFields();
    this.getMemberById();
  }

  disableFields() {
    const isRequest = this.renderForm === RenderFrom.REQUEST;
    const currentProviderId = this.patientForm?.get('providerId')?.value || '';

    this.patientForm = this.fb.group({
      firstName: [{ value: '', disabled: isRequest }, Validators.required],
      lastName: [{ value: '', disabled: isRequest }, Validators.required],
      dateOfBirth: [{ value: '', disabled: isRequest }, Validators.required],
      gender: [{ value: '', disabled: isRequest }, Validators.required],
      email: [{ value: '', disabled: isRequest }, [Validators.required, Validators.email]],
      phone: [{ value: '', disabled: isRequest }, [
        Validators.required,
        Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)
      ]],
      address: [{ value: '', disabled: isRequest }, Validators.required],
      nhsNumber: [{ value: '', disabled: isRequest }],
      comments: [{ value: '', disabled: isRequest }],
      consentToShareData: [false, isRequest ? Validators.requiredTrue : []],
      providerId: [{ value: currentProviderId, disabled: false }, isRequest ? Validators.required : []]
    });
  }


  displayPatientName = (patient: any): string => {
    return patient ? `${patient.firstName} ${patient.lastName}` : '';
  };


  patientList: PatientsData[] = [];

  isDragging = false;

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFiles(files);
      // If you want to upload immediately:
      Array.from(files).forEach(file => {
        if (file instanceof File) {
          this.uploadFileAndStoreDocument(file);
        }
      });
    }
  }

  onAdditional(fileInput: Event) {
    const input = fileInput.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFiles(input.files);
      Array.from(input.files).forEach(file => {
        if (file instanceof File) {
          this.uploadFileAndStoreDocument(file);
        }
      });
    }
  }

  handleFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.uploadedFiles.push(files[i]);
    }
  }

  async uploadFileAndStoreDocument(file: File) {
    try {
      const url = await this.getfiles3Url(file);
      console.log('File uploaded and URL received:', url);
      this.documentList.push(url);
      // this.uploadedFiles.push({ name: url.documentName || file.name });
    } catch (error) {
      console.error('Error uploading file or fetching URL:', error);
    }
  }

  getfiles3Url(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      this.restService.uploadFile(file).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1);
    this.documentList.splice(index, 1);
  }

  submitForm() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '350px';
    // dialogConfig.height = '300px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = this.renderForm == RenderFrom.REQUEST ? 'Confirm' : 'Add';

    dialogRef.componentInstance.mode = this.enumConfirmationMode.ADD;

    if (this.renderForm == RenderFrom.REQUEST)
      dialogRef.componentInstance.message = `
      Are you sure you want to add member`;
    else {
      dialogRef.componentInstance.message = `
      Are you sure you want to request medical evidence for the member`;
    }

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.isSubmitLoading = true;
        if (this.renderForm == RenderFrom.REQUEST)
          this.callRequestApi();
        else
          this.callRegisterApi();
      } else {
        this.patientForm.markAllAsTouched();
      }
    });

  }

  callRegisterApi() {
    const json = {
      ...this.patientForm.value,
      patientDocuments: this.documentList,
      createdby: this.memberService.getLoginUserId(),
      dateOfBirth: this.datepipe.transform(this.patientForm.value.dateOfBirth, 'dd-MM-yyyy')
    };

    if (!this.memberId) {
      this.restService.addMember(json).subscribe({
        next: (response) => {
          if (response) {
            this.notificationService.showNotification('Member added successfully!');
            this.closeDialog();
            this.resetFields();
          } else {
            this.notificationService.showNotification('Failed to add member. Please try again.', 'error');
          }
          this.isSubmitLoading = false;
        },
        error: (error) => {
          this.isSubmitLoading = false;
          this.notificationService.showNotification(error.message, 'error');
        }
      });
    }
    else {
      this.restService.editMember(json, this.memberId).subscribe({
        next: (response) => {
          if (response) {
            this.notificationService.showNotification('Member updated successfully!');
            this.closeDialog();
            this.resetFields();
            this.memberService.emitRefresh();
          } else {
            this.notificationService.showNotification('Failed to update member. Please try again.', 'error');
          }
          this.isSubmitLoading = false;
        },
        error: (error) => {
          this.isSubmitLoading = false;
          this.notificationService.showNotification(error.message, 'error');
        }
      });
    }

  }

  callRequestApi() {
    let json = {}
    if (this.memberSearchControl.value) {
      json = {
        providerId: this.addedProvidersList[0].id,
        patientId: this.memberSearchControl.value.id,
        userId: this.memberService.getLoginUserId()
      };
    }
    else {
      json = {
        userId: this.memberService.getLoginUserId(),
        providerId: this.addedProvidersList[0].id,
        patientDTO: {
          ...this.patientForm.getRawValue(),
          dateOfBirth: this.datepipe.transform(this.patientForm.value.dateOfBirth, 'dd-MM-yyyy'),
          createdby: this.memberService.getLoginUserId(),
          patientDocuments: this.documentList
        },
        createdby: this.memberService.getLoginUserId()
      }
    }
    this.restService.requestME(json).subscribe({
      next: (response) => {
        if (response) {
          this.notificationService.showNotification('Requested medical evidence successfully!');
          this.closeDialog();
          this.memberService.emitRefresh();
          this.resetFields();
        } else {
          this.notificationService.showNotification('Failed to request medical evidence. Please try again.', 'error');
        }
        this.isSubmitLoading = false;
      },
      error: (error) => {
        this.isSubmitLoading = false;
        this.notificationService.showNotification(error.error.message, 'error');
      }
    });
  }

  resetFields(): void {
    this.patientForm.reset();
    this.uploadedFiles = [];
    this.documentList = [];
    this.patientForm.markAsPristine();
    this.patientForm.markAsUntouched();
  }


  closeDialog() {
    this.dialogRef.close();
  }

  getMappedProvider() {
    this.addedProvidersList = [];
    let insurerId = this.memberService.getLoginUserPrimaryId();
    this.restService.getAgentMappedProviderByInsurer(insurerId).subscribe(res => {
      if (res) {
        this.addedProvidersList = res;
      }
    }, err => {
      this.addedProvidersList = [];
    })
  }


  getMemberById(): void {

    if (!this.memberId) return;

    this.restService.getMemberById(this.memberId).subscribe({
      next: (response :PatientData) => {
        this.selectedPatient = response;
        console.log('Patient found from API:', this.selectedPatient);

        this.patientForm.patchValue({
          patientId: this.selectedPatient.patientId,
          firstName: this.selectedPatient.firstName,
          lastName: this.selectedPatient.lastName,
          dateOfBirth: new Date(this.selectedPatient.dateOfBirth),
          gender: this.selectedPatient.gender,
          email: this.selectedPatient.email,
          phone: this.selectedPatient.phone,
          address: this.selectedPatient.address,
          nhsNumber: this.selectedPatient.nhsNumber,
          consentToShareData: false
        });
        this.uploadedFiles = this.selectedPatient.patientDocuments.map(doc => ({
          ...doc,
          name: doc.documentName
        }));
      },
      error: (err) => {
        console.error('Failed to fetch patient by ID:', err);
      }
    });
  }


  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }
}